/* eslint-disable react-hooks/rules-of-hooks */
/* eslint-disable array-callback-return */
/* eslint-disable react/prop-types */
/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable react/jsx-props-no-spreading */
/* eslint-disable-next-line array-callback-return */
import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import PropTypes from 'prop-types';

import { formatNumber, formatDecimalNumber } from '../../utilities/formatHelpers';
import { currencies as currenciesData, exchange } from '../../utilities/constants';
import { useRateDetails } from '../../utilities/sharedHooks/rates';

const ChevronDown = ({ style }) => (
  <i style={style} className="icon-arrow-down-navigation text-shadow" />
);

const BalanceByWallet = ({ selectedWallet, walletBalanceIsGood, principalCurrency, onClick }) => {
  const { t: translate } = useTranslation();
  const [currencyBalance, setCurrencyBalance] = useState('-');
  const [walletFiatBalance, setWalletFiatBalance] = useState();

  const updateAvailableBalance = (wallet) => {
    const currency = currenciesData[wallet.coin];
    const walletBalance = formatNumber(
      wallet.available_balance * currency.conversion,
      currency.decimal
    );
    setCurrencyBalance(walletBalance);
  };
  const { rate } = useRateDetails(selectedWallet?.coin, principalCurrency);

  useEffect(() => {
    updateAvailableBalance(selectedWallet);
    const { formattedAmount } = formatDecimalNumber(
      formatNumber(currencyBalance * rate, exchange.FIAT_VALUE),
      0
    );
    setWalletFiatBalance(formattedAmount);
  }, [rate, selectedWallet, currencyBalance]);

  return (
    <>
      <div className="mt-4">
        <span className="text-shadow text-f6">
          {translate('cryptodraft_calculator_choose_source')}
        </span>
      </div>
      <div
        role="button"
        tabIndex={0}
        onClick={onClick}
        onKeyDown={() => {}}
        className="d-flex flex-row align-items-center justify-content-between mt-2 p-3 bg-light rounded">
        <div className="d-flex flex-row align-items-center justify-content-between w-30">
          <div className="d-flex flex-row align-items-center justify-content-between">
            {selectedWallet?.coin && (
              <img
                style={{ width: '1.5rem', height: '1.5rem' }}
                src={`./assets/icons/${selectedWallet?.coin.toLocaleUpperCase()}.svg`}
                alt={selectedWallet?.coin}
              />
            )}

            <b className="ms-2 text-uppercase">{selectedWallet?.coin}</b>
          </div>
          <ChevronDown style={{ transform: `rotate(0deg)` }} />
        </div>
        <div className="d-flex flex-column text-end">
          <h2 className="m-0 text-f5">
            {currencyBalance.toLocaleUpperCase()} {selectedWallet?.coin.toLocaleUpperCase()}
          </h2>
          <span
            className={`text-f6 text-uppercase ${
              !walletBalanceIsGood ? 'text-danger' : 'text-shadow'
            }`}>
            {walletFiatBalance} {principalCurrency}
          </span>
        </div>
      </div>
    </>
  );
};

export default BalanceByWallet;

BalanceByWallet.propTypes = {
  principalCurrency: PropTypes.string.isRequired,
  walletBalanceIsGood: PropTypes.bool,
  onClick: PropTypes.func,
};
BalanceByWallet.defaultProps = {
  walletBalanceIsGood: true,
  onClick: () => {},
};
